import { render, staticRenderFns } from "./gallery_dummy.vue?vue&type=template&id=24c7c6f7"
import script from "./gallery_dummy.vue?vue&type=script&lang=js"
export * from "./gallery_dummy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports